import styled from 'styled-components'

export const BoxPet = styled.div`
  cursor: pointer;
  display: flex;
  width: 100%;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
`

export const BoxInfoPet = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
`

export const BoxInfoUser = styled(BoxInfoPet)`

`

export const BoxInfoAppointment = styled(BoxInfoPet)`

`

export const BoxResult = styled.div`
  font-family: 'Open Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: #222;
`

export const BoxTags = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  margin-left: 16px;
`

export const PrimaryTags = styled.div`
  display: flex;
  height: 32px;
  padding: 6px 8px;
  align-items: center;
  border-radius: 8px;
  background: #D8EEF6;
  color: #028BB7;
  font-size: 14px;
  font-family: 'Open Sans';
  font-weight: 600;
`

export const SecondaryTag = styled.div`
  display: flex;
  height: 32px;
  padding: 6px 8px;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  border: 1px solid #028BB7;
  background: #FFF;
  color: #028BB7;
  font-size: 13px;
  font-family: 'Open Sans';
  font-weight: 600;
`

export const CardsGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 24px;
  margin-top: 24px;
`

export const Pet = styled.h2`
  font-family: 'Open Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  color: #444;
  margin-bottom: 0;
`

export const User = styled(Pet)`

`

export const Appointment = styled(Pet)`

`

export const Tutor = styled.h3`
  font-family: 'Open Sans';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #555;
  margin-bottom: 0;
  strong {
    font-family: 'Open Sans';
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`
export const Image = styled.div`

`

export const BoxUser = styled(BoxPet)`

`

export const BoxAppointment = styled(BoxPet)`

`

export const CPF = styled(Tutor)`

`

export const BoxEmail = styled(BoxTags)`

`

export const Email = styled(PrimaryTags)`
  font-family: 'Open Sans';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const Button = styled.a`
  cursor: pointer;
`
